function getStorage() {
  if (typeof window !== "undefined" && window.localStorage) {
    return window.localStorage;
  }

  return {
    getItem() {
      return null;
    },
    setItem() {},
    removeItem() {},
  };
}

const storage = getStorage();

const RECENT_EXPLORERS_KEY = "recentExplorers";
const RECENT_PEOPLE_KEY = "recentPeople";
const MAX_RECENT_ITEMS = 6;

function readStorageArray(key) {
  try {
    const value = storage.getItem(key);
    return value ? JSON.parse(value) : [];
  } catch (error) {
    return [];
  }
}

function writeStorageArray(key, value) {
  try {
    storage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // fail silently
  }
}

function upsertRecentItem(key, item, uniqueBy) {
  if (!item?.[uniqueBy]) return;

  const existing = readStorageArray(key);

  const next = [
    item,
    ...existing.filter((entry) => entry?.[uniqueBy] !== item[uniqueBy]),
  ].slice(0, MAX_RECENT_ITEMS);

  writeStorageArray(key, next);
}

export function saveRecentExplorer(item) {
  if (!item?.path || !item?.title) return;

  upsertRecentItem(
    RECENT_EXPLORERS_KEY,
    {
      ...item,
      type: "explorer",
      savedAt: Date.now(),
    },
    "path"
  );
}

export function getRecentExplorers() {
  return readStorageArray(RECENT_EXPLORERS_KEY);
}

export function clearRecentExplorers() {
  storage.removeItem(RECENT_EXPLORERS_KEY);
}

export function saveRecentPerson(person) {
  if (!person?.id || !person?.name) return;

  upsertRecentItem(
    RECENT_PEOPLE_KEY,
    {
      id: person.id,
      name: person.name,
      title: person.title || "",
      summary: person.summary || "",
      path: `/people/${person.id}`,
      section: "People",
      type: "person",
      savedAt: Date.now(),
    },
    "id"
  );
}

export function getRecentPeople() {
  return readStorageArray(RECENT_PEOPLE_KEY);
}

export function clearRecentPeople() {
  storage.removeItem(RECENT_PEOPLE_KEY);
}

export function getAllRecentItems() {
  const explorers = getRecentExplorers();
  const people = getRecentPeople();

  return [...people, ...explorers]
    .sort((a, b) => (b.savedAt || 0) - (a.savedAt || 0))
    .slice(0, MAX_RECENT_ITEMS);
}